/** Navigation only: sessions remain host-scoped and the destination authenticates. */
export function businessWorkspaceUrl(host: string): string | null {
  const preview = /^pr-(\d+)-player\.badmintonwarriors\.com$/.exec(host);
  if (preview) return `https://pr-${preview[1]}-business.badmintonwarriors.com/workspaces`;
  if (host === "staging.badmintonwarriors.com") return "https://staging-business.badmintonwarriors.com/workspaces";
  if (host === "badmintonwarriors.com" || host === "www.badmintonwarriors.com") return "https://business.badmintonwarriors.com/workspaces";
  if (host === "localhost" || host === "127.0.0.1") return "http://127.0.0.1:3001/workspaces";
  return null;
}
